module.exports = __webpack_public_path__ + "img/adfs-logo.45c9f9a8.svg";